import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import Badge from '../Badge'
import TextOnlyButton from '../TextOnlyButton'

const styles = theme => ({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 4px 16px',
    borderBottom: '1px solid #d8d8d8',
  },
  buttons: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    '& button:last-child': {
      marginLeft: '4px',
    },
  },
  selectButton: {
    padding: '6px',
    fontSize: theme.typography.fontSizeSm,
    fontWeight: theme.typography.fontWeightBolder,
  },
})

const SelectTools = ({ badgeVariant, classes, handleSelectAll, handleSelectNone, totalSelected }) => (
  <nav className={cn('toolbar', classes.toolbar)}>
    <Badge label="Selected" value={totalSelected} variant={badgeVariant} />
    <div className={classes.buttons}>
      <TextOnlyButton
        className={classes.selectButton}
        label="Select All"
        onClick={handleSelectAll}
        aria-label="Select All"
      />
      <TextOnlyButton
        className={classes.selectButton}
        label="Unselect All"
        onClick={handleSelectNone}
        aria-label="Unselect All"
      />
    </div>
  </nav>
)

SelectTools.defaultProps = {
  badgeVariant: 'success',
  totalSelected: 0,
}

const SelectToolsComponent = withStyles(styles)(SelectTools)
SelectToolsComponent.displayName = 'SelectTools'
export default SelectToolsComponent
